import { HttpClient } from '@angular/common/http';
import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import { SocialMediaFileTypes } from '../api/models';
import { SocialNetworkMessageFilesService } from '../api/services';

@Directive({
  selector: '[socialMediaFile]',
  standalone: true,
})
export class SocialMediaFileDirective {
  @Input('socialMediaFile') fileId: number;
  @Input() type: SocialMediaFileTypes;

  subscription: Subscription;

  @Output() resultReady: EventEmitter<string> = new EventEmitter();

  constructor(
    protected http: HttpClient,
    private socialNetworkMessageFiles: SocialNetworkMessageFilesService
  ) {}

  ngOnChanges(): void {
    this.fetchFileApi();
  }

  fetchFileApi() {
    if (this.subscription) this.subscription.unsubscribe();

    this.subscription = this.socialNetworkMessageFiles
      .socialNetworkMessageFilesDownloadSocialMediaMessageFileById({
        Id: this.fileId,
      })
      .subscribe((result) => {
        const blobFile = this.dataURItoBlob(result?.data);
        this.resultReady.emit(URL.createObjectURL(blobFile));
      });
  }

  //convert string to blob
  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], {
      type:
        this.type == SocialMediaFileTypes.Image
          ? 'image/png'
          : this.type == SocialMediaFileTypes.Pdf
          ? 'application/pdf'
          : this.type == SocialMediaFileTypes.Audio
          ? 'audio/mp3'
          : 'video/mp4',
    });
    return blob;
  }
}
